import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CSVLink } from "react-csv";
import moment from "moment";
import dayjs from "dayjs";

import { fetchAdjLogs } from "../../redux/actions/actionStandaloneAdj";
import AdjustmentFilter from "./components/AdjustmentFilter";
import { applyAdjFilter } from "./adjustmentHelperFunction";
import filter from "../../assets/filter.svg";
import download from "../../assets/download.svg";
import { Navbar } from "../../Components/Navbar";
import arrow from "../../assets/arrowLeftGreen.svg";
import Loading from "../../Components/Common/Loader/Loading";
import { motion } from "framer-motion";

import AdjustmentsNav from './AdjustmentsNav';
import Sidebar from "../../myfin_v2/elements/Sidebar"
import commoncss from "../../myfin_v2/css/common.module.css"
import bookclosuretablecss from "../../myfin_v2/css/bookclosuretable.module.css";



const adjustmentsTable = {
  minWidth: "1045px",
  height: "100vh",
};

const AdjustmentsLog = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const project_id = localStorage.getItem("project_id");
  const tb_id = localStorage.getItem("tb_id");

  const {
    logLoading,
    log_error_message,
    logIsSuccess,
    logData,
    copyLogData
  } = useSelector((initialState) => initialState.ADJStandaloneReducer);
  const filterData = useSelector((initialState) => initialState.reducer.filter);

  const [exportAdjustments, setExportAdjustments] = useState([]);
  const [filterShow, setFilterShow] = useState(false);
  const [state, setstate] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {

    if (logData && logData?.length > 0) {
      logData.forEach((element) => {
        element.data.forEach((row, index) => {
          setExportAdjustments((exportAdjustments) => [
            ...exportAdjustments,
            {
              modifiedDate: moment(element.timestamp).format("DD/MM/YYYY"),
              modifierEmail: element.email,
              adjustedLedger: row.ledger_name,
              cy: row.cy,
              adjustment: row.adjusted_amount,
              remarks: element.remarks,
              "Log Action": element.logAction,
            },
          ]);
        });
      });
    }

  }, [logData]);

  useEffect(() => {
    // if (!logIsSuccess) {
    dispatch(fetchAdjLogs(project_id, tb_id));
    // }
  }, []);


  const csvLink = {
    data: [...exportAdjustments],
    filename: "AdjustmentLogs.csv",
  };

  const handleApplyFilter = () => {
    dispatch(applyAdjFilter(copyLogData, filterData, "ADJ_LOG_FILTER"));
  }

  const nf = new Intl.NumberFormat();

  const filteredLogData = logData?.map((adj) => {
    if(!searchValue) return adj;
    const search = searchValue.toLowerCase();
    const filteredRows = adj.data.filter(val => {
       return (
            (val.ledger_name && val.ledger_name.toLowerCase().includes(search)) ||
            (val.ledger_code && val.ledger_code.toLowerCase().includes(search)) ||
            (adj.email && adj.email.toLowerCase().includes(search)) ||
            (adj.logAction && adj.logAction.toLowerCase().includes(search))
       );
    });
    return { ...adj, data: filteredRows };
  }).filter(adj => adj.data && adj.data.length > 0);

  return (

    <>

      <div className={commoncss.pageLayout}>
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }} className={commoncss.w100} style={{ maxHeight: "95vh", overflowY: "hidden" }} >
            <AdjustmentsNav setFilterShow={setFilterShow} csvLink={csvLink} searchValue={searchValue} setSearchValue={setSearchValue} />
            {filteredLogData?.length > 0 &&
              (
              logLoading ? <Loading /> : <>
                <div className={`${bookclosuretablecss.bookClosureTableContainer} mt-3`} style={{ margin: "0 auto", width: "calc(100% - 32px)", maxHeight: "calc(100vh - 120px)", overflowY: "auto", borderRadius: "10px", border: "1px solid #dddddd" }}>
                  <table className={`${bookclosuretablecss.bookClosureTable} ${bookclosuretablecss.bookclosureEntries}`}>
                    <thead style={{ backgroundColor: "#E5E7E9", position: "sticky", top: 0, zIndex: 1, boxShadow: "0 1.5px 0 0 #dedede" }}>
                      <tr>
                        <th className="text-left text-uppercase font-size-14 custom-font-600 pl-4"  > MODIFIED DATE </th>
                        <th className="text-left text-uppercase font-size-14 custom-font-600" > MODIFIER ID </th>
                        <th className="text-center text-uppercase font-size-14 custom-font-600" > LEDGER CODE </th>
                        <th className="text-left text-uppercase font-size-14 custom-font-600 pl-3" > LEDGER NAME </th>
                        <th className="text-right text-uppercase font-size-14 custom-font-600" > CURRENT YEAR </th>
                        <th className="text-right text-uppercase font-size-14 custom-font-600" > ADJUSTMENT </th>
                        <th className="text-right text-uppercase font-size-14 custom-font-600 pr-4" >Log Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredLogData?.length > 0 && filteredLogData.map((adj, i) => {
                        var email = adj.email;
                        var date = adj.timestamp.split(",")[0];

                        return adj?.data?.map((val, ix) => {
                          return (
                            <tr key={ix}>
                              <td className={`text-left ${commoncss.noBorder} pl-4`} >{dayjs(date).format("DD MMM YYYY")}</td>
                              <td className={`text-left ${commoncss.noBorder}`} >{email}</td>
                              <td className={`text-center  ${commoncss.noBorder}`}>{val?.ledger_code}</td>
                              <td className={`text-left pl-3 ${commoncss.noBorder}`}>{val?.ledger_name}</td>
                              <td className={`text-right  ${commoncss.noBorder}`}>{nf.format(val.cy)}</td>
                              <td
                                className={`text-right ${commoncss.noBorder} ${commoncss.fw600} ${val.adjusted_amount < 0 ? commoncss.clrRed : commoncss.clrGreen
                                  }`}
                              >
                                {nf.format(val.adjusted_amount)}
                              </td>
                              <td className={`text-right  ${commoncss.noBorder} pr-4`}>{adj?.logAction}</td>
                            </tr>
                          )
                        });
                      })}

                    </tbody>
                  </table>
                </div>
              </>
              )
            }


            {(!filteredLogData || filteredLogData.length <= 0) &&
              <p className="w-100 text-center text-secondary" > No Adjustment Logs </p>
            }

          </motion.div>
        </div>
        <AdjustmentFilter
          actionFrom={"log"}
          show={filterShow}
          handleApplyFilter={handleApplyFilter}
          setFilterShow={setFilterShow}
          setObject={() => { }}
          state={state}
          setstate={setstate}
        />
      </div >
    </>

  );
};

export default AdjustmentsLog;
